import { Box, DialogContent, DialogTitle } from "@mui/material";
import { usersBusiness } from "api/bussiness/user-role-permission/users-bussiness";
import { UpdateUser } from "api/models/request/user-role/users";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect } from "react";
import { string } from "yup";
import { DynamicForm } from "../../../../commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "../../../../commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "../../../../commons/ultilities/dynamic-form/models/control";
import { useStores } from "../../../../mobx-stores/_root-store";
import { DialogForm } from "../../../../share-components/templates/form/dialog-form";

export const EditUser = observer(() => {
  const {
    catalogueStore: { rolesAsOptionItems, getRoles },
    userManagement: { openEdit, setProp, userSelected, replaceUser },
  } = useStores();
  const {
    form: { controls, isValid, isDirty },
    submitHandler,
    setDefaults,
    defaults,
    getControl,
  } = useForm<UpdateUser>(
    {
      userName: {
        gridSize: 6,
        label: "Tài khoản",
        type: InputType.text,
        validattionYupSchema: string().trim().required().max(256),
        disabled: true,
      },
      name: {
        gridSize: 6,
        label: "Tên người dùng",
        type: InputType.text,
        validattionYupSchema: string().trim().required().max(64),
      },
      email: {
        gridSize: 7,
        label: "Email",
        type: InputType.text,
        validattionYupSchema: string().email().required().max(256),
      },
      phoneNumber: {
        gridSize: 5,
        label: "Số điện thoại",
        type: InputType.text,
        validattionYupSchema: string().max(16),
      },
      roleNames: {
        gridSize: 12,
        label: "Vai trò",
        optionItems: [],
        type: InputType.autoCompleteMultiple,
      },
      isActive: {
        gridSize: 12,
        label: "Hoạt động",
        type: InputType.checkbox,
      },
    },
    {
      name: userSelected?.name || "",
      userName: userSelected?.userName || "",
      email: userSelected?.email || "",
      phoneNumber: userSelected?.phoneNumber || "",
      isActive: userSelected?.isActive || false,
      roleNames: [],
    }
  );

  const getRolesOfUser = useCallback(async () => {
    if (!userSelected?.id) return;

    const res = await usersBusiness.getUserRoles(userSelected?.id);
    const defaultRoles = res.items
      ?.filter((x) => x.name)
      ?.map((x) => x.name) as string[];
    const newDefault = cloneDeep(defaults);
    newDefault.roleNames = defaultRoles;
    setDefaults(newDefault);
  }, [defaults, setDefaults, userSelected?.id]);

  useEffect(() => {
    getRoles();
    getRolesOfUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (rolesAsOptionItems) {
      getControl("roleNames").setProp(
        "optionItems",
        cloneDeep(rolesAsOptionItems)
      );
    }
  }, [getControl, getRolesOfUser, rolesAsOptionItems]);

  const saveHandler = useCallback(
    async (data: UpdateUser) => {
      if (!userSelected?.id) return;
      const res = await usersBusiness.updateUser(userSelected?.id, data);
      replaceUser(res);
      setProp("userSelected", null);
      setProp("openEdit", false);
    },
    [replaceUser, setProp, userSelected?.id]
  );

  return (
    <DialogForm
      open={openEdit}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isDirty || !isValid,
      }}
    >
      <DialogTitle>Sửa tài khoản</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
